export const BEHAVIOR_BRANCH_TRIGGER_TAG = '__behavior-branch__';
